export default __webpack_public_path__ + "static/media/icon-default-whizzy.2943f78c.svg";